<script lang="ts">
  import Registrierung from '../Registrierung.svelte';
</script>

<section id="registrieren" class="abschnitt tb-gradient">
  <div class="breite zwei-spalten">
    <div>
      <span class="hero-vorzeile">Kostenlos, ohne Verpflichtung</span>
      <h2 class="hell-titel">Jetzt registrieren</h2>
      <p class="hero-lead">
        Leg dir in einer Minute deinen Kundenzugang an — ganz
        ohne Paket oder Zahlung. Danach entscheidest du in Ruhe, welche Hilfe du brauchst.
      </p>
      <ul class="checkliste hell-liste">
        <li>Kein Tarif, keine Zahlungsdaten</li>
        <li>Zugang zu deinem persönlichen Kundenbereich</li>
        <li>Dein persönlicher Ansprechpartner meldet sich, sobald du möchtest</li>
      </ul>
    </div>
    <Registrierung />
  </div>
</section>

<style>
  .hell-titel {
    color: #fff;
  }

  .hell-liste li {
    color: var(--tb-light-100);
  }
</style>
